'use strict';

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var directoryContent = function directoryContent(cid, node, unixfs, path, resolve, depth, ipld, options) {
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var options,
          offset,
          length,
          links,
          _iterator,
          _step,
          link,
          result,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 0 && _args[0] !== undefined ? _args[0] : {};
              offset = options.offset || 0;
              length = options.length || node.Links.length;
              links = node.Links.slice(offset, length);
              _iterator = _createForOfIteratorHelper(links);
              _context.prev = 5;

              _iterator.s();

            case 7:
              if ((_step = _iterator.n()).done) {
                _context.next = 16;
                break;
              }

              link = _step.value;
              _context.next = 11;
              return _awaitAsyncGenerator(resolve(link.Hash, link.Name, "".concat(path, "/").concat(link.Name), [], depth + 1, ipld, options));

            case 11:
              result = _context.sent;
              _context.next = 14;
              return result.entry;

            case 14:
              _context.next = 7;
              break;

            case 16:
              _context.next = 21;
              break;

            case 18:
              _context.prev = 18;
              _context.t0 = _context["catch"](5);

              _iterator.e(_context.t0);

            case 21:
              _context.prev = 21;

              _iterator.f();

              return _context.finish(21);

            case 24:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[5, 18, 21, 24]]);
    }));

    return function () {
      return _ref.apply(this, arguments);
    };
  }();
};

module.exports = directoryContent;